var host = typeof process.env.API_HOST !== "undefined" ? process.env.API_HOST : "https://www.xe.com";
var toCurrencyApp = {
  forAndroid: {
    inMainNav: "https://play.google.com/store/apps/details?id=com.xe.currency&referrer=utm_source%3DWebsite%26utm_medium%3Dbutton%26utm_term%3Dget%2Bthe%2Bapp%26utm_campaign%3DGet%20the%20app",
    onAppsPage: "https://play.google.com/store/apps/details?id=com.xe.currency&referrer=utm_source%3DWebsite%26utm_campaign%3DApp%2520landing%2520page",
    onHomePage: "https://play.google.com/store/apps/details?id=com.xe.currency&referrer=utm_source%3DXE-Site-v4"
  },
  foriOS: {
    inMainNav: "https://apps.apple.com/app/apple-store/id315241195?pt=211875&ct=Get%20the%20app&mt=8",
    onAppsPage: "https://apps.apple.com/app/apple-store/id315241195?pt=211875&ct=Website%20-%20App%20landing%20page&mt=8",
    onHomePage: "https://apps.apple.com/app/apple-store/id315241195?pt=211875&ct=XE-Site-v4&mt=8"
  }
};
var toXERA = "https://xera.xe.com";
var toXECD = "https://xecd.xe.com";
var toXEMT = {
  forConsumerReg: {
    main: "https://transfer.xe.com/signup",
    personal: "https://transfer.xe.com/signup/personal/step1",
    redirect: "https://transfer.xe.com/signup/Track/Redirect"
  },
  forConsumerLogin: {
    main: "https://transfer.xe.com/account/login",
    home: "https://transfer.xe.com/account/login/home"
  },
  forCorporateReg: "https://1.transfer.xe.com/signup/business/step1.aspx"
};
export default {
  host: host,
  toCurrencyApp: toCurrencyApp,
  toXERA: toXERA,
  toXECD: toXECD,
  toXEMT: toXEMT
};